module.exports = __webpack_public_path__ + "static/img/bg_a.0b84467b.png";